'use restrict';

var reportOfferActivityCtrl = function ($scope, railApi) {
 
    $scope.total = 0;
    $scope.results = {};
    $scope.hgForm = null;
    $scope.myLength = null;
    $scope.offerLetterActivityData = [];

    $scope.getOfferActivityReport = function(hgForm, railApiName){
        railApi.get('approval_emails/get_offer_activty_report', hgForm).promise.then(function(data){
            $scope.offerLetterActivityData = data
            $scope.myLength = data.length
        })
    }

    $scope.formatAnswer = function (answer) {
        if (answer == "{NULL}"){
            answer = "N/A"
        }else{
            answer = answer.replaceAll('"', '');
            answer = answer.replaceAll('{', '');
            answer = answer.replaceAll('}', '');
            answer = answer.replaceAll(',', ',\n');
            answer = answer.replaceAll(/[\[\]']+/g,'')
            answer = answer.split(', ').join('\n');
        }
    
        return answer
     };

    $scope.sortResultsBy = function(selection) {
        $scope.toggle = !$scope.toggle
        if (selection == 'author_name') {
            if ($scope.toggle){
                $scope.offerLetterActivityData = $scope.offerLetterActivityData.sort(function(a, b){
                    if (a.author_name < b.author_name) {return -1};
                    if (a.author_name > b.author_name) {return 1};
                    return 0;  
                    })
            }else{
                $scope.offerLetterActivityData = $scope.offerLetterActivityData.reverse(function(a, b){
                    if (a.author_name < b.author_name) {return -1};
                    if (a.author_name > b.author_name) {return 1};
                    return 0;  
                    })
            }
        }
        if (selection == 'candidate_name') {
            if ($scope.toggle){
                $scope.offerLetterActivityData = $scope.offerLetterActivityData.sort(function(a, b){
                    if (a.candidate_name < b.candidate_name) {return -1};
                    if (a.candidate_name > b.candidate_name) {return 1};
                    return 0;  
                    })
            }else{
                $scope.offerLetterActivityData = $scope.offerLetterActivityData.reverse(function(a, b){
                    if (a.candidate_name < b.candidate_name) {return -1};
                    if (a.candidate_name > b.candidate_name) {return 1};
                    return 0;  
                    })
            }
        }
    }
    //  $scope.calculateTotal = function(result){
    //      var myTotal = 0;         
    //      for(var i = 0; i < result.length; i++){
    //          var logsNum = result[i][1];
    //          myTotal = myTotal + logsNum;
    //      }
 
    //      $scope.total = myTotal;
    //  };
 
    // $scope.getUserAccessLogsReportData = function(hgForm, railApiName) {

    //   railApi.get('user_access_logs/').promise.then(function(myData) {
    //       $scope.allLogs = myData;

    //       $scope.userAccessLogs = $scope.allLogs.filter(function(item) {
    //         return item.date.toISOString().split('T')[0] >= hgForm.start_date.toISOString().split('T')[0] && item.date.toISOString().split('T')[0] <= hgForm.end_date.toISOString().split('T')[0];
    //       });
    //       $scope.userAccessLogsNumber = $scope.userAccessLogs.length;
    //     });
    //   }

    // $scope.int_to_ip = function(ipInt) { //convert int ipaddress to 0.0.0.0 format
    //     return ( (ipInt>>>24) +'.' + (ipInt>>16 & 255) +'.' + (ipInt>>8 & 255) +'.' + (ipInt & 255) );
    // }
};
 
module.exports = reportOfferActivityCtrl;
